import { render } from "./dashboardSummary.vue?vue&type=template&id=20c70ffd&scoped=true"
import script from "./dashboardSummary.vue?vue&type=script&lang=js"
export * from "./dashboardSummary.vue?vue&type=script&lang=js"

import "./dashboardSummary.vue?vue&type=style&index=0&id=20c70ffd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c70ffd"]])

export default __exports__